<template>
    <v-container>

        <v-row>

            <v-col cols="12" sm="3" md="2">
                <!-- CONDICIONAL QUE DISABLEE EL BOTON EN CASO SEA EL WEBMASTER -->
                <span>Contenidos</span>
                <v-radio-group v-model="malla.contenidoTipo" @change="getQuery">
                    <v-radio label="Inteligenio" :value="1"></v-radio>
                    <v-radio label="Colegio" :value="0"></v-radio>
                </v-radio-group>
            </v-col>


            <v-col cols="12" md="2" sm="6">
                <AutocompleteComp v-model="malla.id_nivel" textLabel="Nivel" :items="nivel" item-value="id"
                    item-text="desc_nivel" @change="filtrarXGradosNivel()" :isDisable="inhabilitarNivel" />
            </v-col>

            <v-col cols="12" md="2" sm="6">
                <AutocompleteComp v-model="malla.id_grado" textLabel="Grados" :items="filtroGrado" item-value="id"
                    item-text="desc_grado" @change="filtrarAreasXNiveles()" :isDisable="inhabilitarGrado" />
            </v-col>

            <v-col cols="12" md="3" sm="6">
                <AutocompleteComp v-model="malla.id_area" textLabel="Áreas" :items="filtroArea" item-value="id"
                    item-text="desc_area" @change="filtrarCursosXAreas()" :isDisable="inhabilitarArea" />
            </v-col>

            <v-col cols="12" md="3" sm="6">
                <AutocompleteComp v-model="malla.id_curso" textLabel="Curso" :items="filtroCurso" item-value="id"
                    item-text="desc_curso" @change="ObetnerClases()" :isDisable="inhabilitarCurso" />
            </v-col>
        </v-row>

        <v-row>

            <v-col cols="12">
                <ComundataTablecomp :headers="MallacurricularHeaders" :items="clases" whitSearch :search="search">
                    <template v-slot:action_cuaderno_estudiante="{ item }">
                        <ButtonComp v-if="item.cuaderno_trabajo && malla.contenidoTipo == 1"
                            @click="download(URL_SPACE + '/' + item.cuaderno_trabajo)" downloadButton
                            tooltipText="Descargar cuaderno de actividades del estudiante" />
                        <ButtonComp v-else-if="item.cuaderno_trabajo && malla.contenidoTipo == 0"
                            :href="URL_SPACE + '/' + item.cuaderno_trabajo" downloadButton
                            tooltipText="Descargar cuaderno de actividades del estudiante" />
                        <ButtonComp v-else downloadButton disabled />
                    </template>

                    <template v-slot:action_cuaderno_docente="{ item }">
                        <ButtonComp v-if="item.cuaderno_trabajo_docente && malla.contenidoTipo == 1"
                            @click="download(URL_SPACE + '/' + item.cuaderno_trabajo_docente)" downloadButton
                            tooltipText="Descargar cuaderno de actividades del docente" />
                        <ButtonComp v-else-if="item.cuaderno_trabajo_docente && malla.contenidoTipo == 0"
                            :href="URL_SPACE + '/'  + item.cuaderno_trabajo_docente" downloadButton
                            tooltipText="Descargar cuaderno de actividades del docente" />
                        <ButtonComp v-else downloadButton disabled />
                    </template>

                    <template v-slot:action_sesion="{ item }">
                        <ButtonComp v-if="item.id_sa && malla.contenidoTipo == 1" @click="GenerarDocumentoSa(item.id_sa)"
                            tooltipText="Sesión de aprendizaje" downloadButton />
                        <ButtonComp v-if="item.id_sa && malla.contenidoTipo == 0"
                            @click="GenerarDocumentoSaColegio(item.id_sa)" tooltipText="Descargar sesión de aprendizaje"
                            downloadButton />
                        <ButtonComp v-if="item.id_sa == null" disabled downloadButton />
                    </template>

                    <template v-slot:action_clases="{ item }">
                        <ButtonComp v-if="componenteEvento.visualizar_submodulo"
                            @click="visualizarClase(item.id_clase, malla.contenidoTipo)" verButton
                            tooltipText="Ver clases" />
                    </template>
                </ComundataTablecomp>

            </v-col>
        </v-row>


        <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal">
        </component>

    </v-container>
</template>
<script>

import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "@/helpers/axios"
import { mapMutations, mapGetters, mapActions } from 'vuex'
import VisorContenidoCk1 from '@/views/Manager/GestionContenido/viewGC/visorGestorContenido'; //ESTE ES EL COMPONENTE GLOBAL PARA VISUALIZASR DIAPOSITVAS
import AutocompleteComp from '../../components/ComponentsEst/AutocompleteComp.vue';
import ButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import ComundataTablecomp from '../../components/ComponentsEst/ComundataTablecomp.vue';
import { MallacurricularHeaders } from '../../helpers/headersTable';


export default {
    name: 'mallaCurricular',
    id_perfil: '',

    components: {
        VisorContenidoCk1,
        AutocompleteComp,
        ButtonComp,
        ComundataTablecomp
    },

    mounted() {
        //TRAER EL ID DEL PERFIL 
        this.id_perfil = sessionStorage.getItem('id_perfil')
        this.loadMain()
    },


    created() {
        this.actualizarParamentro()
    },

    data() {
        return {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente: { 'id_submodulo': 76, "id_modulo": 7 }, //sud_modulo y modulo

            datoLogin: sessionStorage, // variables de sesion del usuario
            URL_SPACE: BUCKET_ORIGIN_SPACE,
            test: false,
            ////////////////////////////////////////////////////////
            MallacurricularHeaders,
            malla: [],
            nivel: [],
            grado: [],
            areaNivel: [],
            areaGrado: [],
            cursos: [],
            search: '',
            clases: [],
            filtroArea: [],
            filtroGrado: [],
            filtroCurso: [],

            datos: [],

            inhabilitarNivel: true,
            inhabilitarGrado: true,
            inhabilitarArea: true,
            inhabilitarCurso: true,


            /////////////////////////
            // visor de contenidos
            compName: null,
            estadoComponente: false,
            parametroComp: {},

            ///////////////////////////

            // ruta de contenido para colegio = 0
            ruta_api: API_URL,  // ruta del servidor
            // ruta de contenido clicken1 = 1




        }
    },

    computed: {
        ...mapGetters('login', ['componenteEvento']),
        // link para la sesión de aprendizaje
        linkSesionAprendizaje() {
            if (this.malla.sesion_aprendizaje) {
                const tipo = this.malla.tipo_contenido
                const sesion = this.malla.sesion_aprendizaje
                // si es clicken1 o del colegio 
                if ([1, 0].includes(tipo))
                    return `${this.ruta_api + sesion}`
                else return null
            } else {
                return null
            }
        },
    },
    methods: {
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },

        loadMain() {
            this.limpiarForm()

        },
        async download(url) {
            const _url = url.split("/");

            try {
                let response = await fetch(url);

                if (response) {
                    // Para entender mejor esto pueden leer el archivo file.js
                    this.$Files['downloadFetch']({ url: url, filename: _url[_url.length - 1] });
                }
            } catch (error) {
                if (error) {
                    let resp = error.response.data;
                    this.setEnviarMens({
                        tipo: resp.messageT,
                        mensaje: ` ${resp.message}`,
                        tiempo: null,
                    });
                }
            }
        },

        // cargar
        async getQuery() {

            try {
                this.inhabilitarNivel = false
                this.inhabilitarGrado = true
                this.inhabilitarArea = true
                this.inhabilitarCurso = true

                this.malla.id_nivel = ''
                this.malla.id_grado = ''
                this.malla.id_area = ''
                this.malla.id_curso = ''
                this.clases = []

                var response = ""

                // Contenido de Clicken1
                if (this.malla.contenidoTipo == "1") {

                    response = await axios.post(`/academico/mallaCurricular/getQueryCk1`, {
                        id_usuario: this.datoLogin.id,
                        id_colegio: this.datoLogin.id_colegio,
                        id_periodo: this.datoLogin.id_ano_lectivo
                    })
                    // console.log(JSON.stringify(response.data))

                    // Contenido del Colegio
                } else {

                    let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`
                    response = await axios.get(`/academico/mallaCurricular/getQueryColegio${params}`)
                    // console.log(JSON.stringify(response.data))

                }

                this.nivel = response.data.Nivel
                this.grado = response.data.Grado
                this.areaNivel = response.data.AreaNivel
                this.areaGrado = response.data.AreaGrado
                this.cursos = response.data.Cursos

            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error}`, tiempo: null })
            }
        },

        // fitrar grados y areas por niveles
        filtrarXGradosNivel() {

            this.inhabilitarGrado = false
            this.inhabilitarArea = false
            this.inhabilitarCurso = true
            this.malla.id_area = ""
            this.malla.id_curso = ""
            this.clases = []

            // filtro de grados por niveles
            this.filtroGrado = this.grado.filter(el => el.id_nivel == this.malla.id_nivel)
            // filtro de areas por niveles
            this.filtroArea = this.areaNivel.filter(el => el.id_nivel == this.malla.id_nivel)

        },

        // traer las areas por grados
        filtrarAreasXGrados() {

            this.inhabilitarArea = false
            this.inhabilitarCurso = true
            this.malla.id_curso = ""
            this.malla.id_area = ""
            this.clases = []

            this.filtroArea = this.areaGrado.filter(el => el.id_grado == this.malla.id_grado)

        },

        //traer area por niveles
        filtrarAreasXNiveles() {
            this.inhabilitarArea = false
            this.inhabilitarCurso = true
            this.malla.id_curso = ""
            this.malla.id_area = ""
            this.clases = []
            this.filtroArea = this.areaNivel.filter(el => (el.id_nivel == this.malla.id_nivel && el.id_grado == this.malla.id_grado))

        },

        // traer los cursos
        async filtrarCursosXAreas() {
            // los cursos se tienen que filtrar por grados y area
            this.inhabilitarCurso = false
            this.malla.id_curso = ""
            // filtro por grado

            let filtroCursoGrado = this.cursos.filter(el => el.id_grado == this.malla.id_grado)
            // filtro por Area
            this.filtroCurso = filtroCursoGrado.filter(el => el.id_area == this.malla.id_area)

            await this.ObetnerClases();

        },

        // obterner las clases de los gestor de contenidos segun los filtros seleccionados
        async ObetnerClases() {
            try {
                // let params = Object.assign({periodo: this.datoLogin.id_ano_lectivo}, this.asociarCl)
                // contenido clicken 1
                if (this.malla.contenidoTipo == "1") {
                    let response = await axios.post(`/academico/mallaCurricular/getClasesCk1`, this.malla)
                    //let response = await axios.post(`/academico/progDocente/getClasesCk1`,this.malla)

                    this.clases = response.data.Clases

                    // contenido del colegio

                } else if (this.malla.contenidoTipo == "0") {

                    let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`
                    let response = await axios.post(`/academico/mallaCurricular/getClasesColegio${params}`, this.malla)

                    this.clases = response.data.Clases
                }

            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error}`, tiempo: null })
            }
        },

        limpiarForm() {

            this.nivel = []
            this.grado = []
            this.areas = []
            this.cursos = []

            this.malla = {
                id_nivel: '', id_grado: '', id_area: '', id_curso: '',
                contenidoTipo: '', periodo: this.datoLogin.id_ano_lectivo,
                id_usuario: this.datoLogin.id
            }

            this.inhabilitarNivel = true
            this.inhabilitarGrado = true
            this.inhabilitarArea = true
            this.inhabilitarCurso = true

        },

        //////////////////////////////////////
        // VISOR DE CONTENIDO DEL COLEGIO Y MANAGER

        // botos para visualizar clases de la programacion de contenido
        async visualizarClase(id_clase, tipo_contenido) {

            let datosVGC = Object.assign({ evento: "view", id_clase, miniatura: false, id_diapositiva: 1, tipo_contenido })


            // if (tipo_contenido == 1) {
            this.compName = "VisorContenidoCk1"
            this.estadoComponente = true
            this.parametroComp = datosVGC

            // } else {
            // this.compName = "VisorContenidoColegio"
            // this.estadoComponente = true
            // this.parametroComp = datosVGC
            // }

        },

        // funcion para cerrar modal
        CloseModal() {
            this.estadoComponente = false
            // this.verTema = true
            // this.LoadMain()
        },



        async GenerarDocumentoSaColegio(id_sa) {
            try {
                //  this.descargandoDocumento = true;    
                const params = {
                    id_colegio: this.datoLogin.id_colegio
                }

                let url = `/academico/sesionAprendizaje/${id_sa}/documento/`
                let res = await axios.post(url, params, { responseType: "blob" });
                var fileURL = window.URL.createObjectURL(new Blob([res.data]));
                var fileLink = document.createElement("a");

                fileLink.href = fileURL;
                fileLink.setAttribute("download", `sesion_aprendizaje_${id_sa}.pdf`);
                document.body.appendChild(fileLink);

                fileLink.click();
                // this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: 6000}) 

            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `Error al generar el documento`, tiempo: null })
            }
        },

        async GenerarDocumentoSa(id_sa) {
            console.log(`GenerarDocumentoSa : ${id_sa}`)

            try {
                //  this.descargandoDocumento = true;    
                const params = {
                    id_colegio: this.datoLogin.id_colegio
                }

                let url = `/manager/sesionAprendizaje/${id_sa}/documento/`
                let res = await axios.post(url, params, { responseType: "blob" });
                var fileURL = window.URL.createObjectURL(new Blob([res.data]));
                var fileLink = document.createElement("a");

                fileLink.href = fileURL;
                fileLink.setAttribute("download", `sesion_aprendizaje_${id_sa}.pdf`);
                document.body.appendChild(fileLink);

                fileLink.click();
                // this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: 6000}) 

            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `Error al generar el documento`, tiempo: null })
            }
            // this.descargandoDocumento = false;  

        },
    }
}

</script>